/**
 * Determines whether a given URL string is a valid, displayable browser image URL.
 * Storage keys like "logo/usr_123/uuid.png", "certificate/...", etc. are internal
 * storage identifiers and must never be used directly in an <img> tag's src.
 */
export function isDisplayableUrl(url) {
  if (!url || typeof url !== "string") return false;
  const trimmed = url.trim();
  if (!trimmed) return false;

  // Stored S3 / backend keys must never be used directly in an <img> tag src
  const rawKeyPattern =
    /^\/?(logo|avatar|certificate|registration-document)\/[^/]+\/[^/]+$/i;
  if (rawKeyPattern.test(trimmed)) return false;
  if (trimmed.startsWith("s3://")) return false;

  return (
    trimmed.startsWith("http://") ||
    trimmed.startsWith("https://") ||
    trimmed.startsWith("data:") ||
    trimmed.startsWith("blob:") ||
    trimmed.startsWith("/api/storage/files/") ||
    (trimmed.startsWith("/") &&
      !trimmed.startsWith("//") &&
      !trimmed.startsWith("/logo/") &&
      !trimmed.startsWith("/avatar/") &&
      !trimmed.startsWith("/certificate/") &&
      !trimmed.startsWith("/registration-document/"))
  );
}
